import {
  Component, HostListener, Input,
  OnInit, SimpleChanges
} from '@angular/core';
import {SpecLineModel, PropertyLineModel, StateService} from "web-shared";
import {BaseComponent, GLOBAL, Guid, IdTextValueModel} from "common-shared";
import {instanceToInstance, plainToInstance} from "class-transformer";
import {takeUntil} from "rxjs/operators";
import {ResourceService} from "../../../manufacturing/resources/resource.service";

@Component({
  selector: 'app-favourites',
  templateUrl: './favourites.component.html',
  styles: []
})
export class FavouritesComponent extends BaseComponent implements OnInit {
  @Input() specs: SpecLineModel[] = [];
  favourites: IdTextValueModel[] = []
  hasFavourites: boolean;
  showAddNew: boolean;
  editableFavourite: IdTextValueModel;
  @Input() externalLinks: IdTextValueModel[] = [];

  constructor(private resourceService: ResourceService, private stateService: StateService) {
    super();
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.specs?.currentValue) {
      this.prepareFavourites();
    }
  }

  private prepareFavourites() {
    if (this.specs) {
      this.favourites = [];
      const favouritesSpec = this.specs.find(spec => spec.PropertyId === GLOBAL.Properties.Favourites);
      if (favouritesSpec?.Value) {
        const favourites = plainToInstance(IdTextValueModel, <string[]>JSON.parse(favouritesSpec.Value));
        if (favourites.length) {
          favourites.forEach(favourite => {
            this.favourites.push({Id: favourite.Id, Text: favourite.Text, Value: favourite.Value});
          });
        }
      }
      this.hasFavourites = this.favourites.length > 0;
    }
  }

  openEditRow(favourite: IdTextValueModel) {
    this.showAddNew = false;
    this.editableFavourite = instanceToInstance(favourite);
  }

  delete() {
    this.favourites = this.favourites.filter(favourite => favourite.Id !== this.editableFavourite.Id);
    let propertyLine = new PropertyLineModel();
    propertyLine.Id = this.specs.find(spec => spec.PropertyId === GLOBAL.Properties.Favourites)?.LineId;
    propertyLine.PropertyId = GLOBAL.Properties.Favourites;
    propertyLine.Value = JSON.stringify(this.favourites);
    this.resourceService.editPropertyLine(propertyLine).pipe(takeUntil(this.componentDestroyed)).subscribe(() => {
      this.editableFavourite = null;
      this.updateSpecs();
    });
  }

  @HostListener('keydown.esc', ['$event'])
  cancel() {
    this.showAddNew = false;
    this.editableFavourite = null;
  }

  edit() {
    const modifiableFavourite = this.favourites.find(favourite => favourite.Id === this.editableFavourite.Id);
    modifiableFavourite.Text = this.editableFavourite.Text;
    modifiableFavourite.Value = this.editableFavourite.Value
    let propertyLine = new PropertyLineModel();
    propertyLine.Id = this.specs.find(spec => spec.PropertyId === GLOBAL.Properties.Favourites)?.LineId;
    propertyLine.PropertyId = GLOBAL.Properties.Favourites;
    propertyLine.Value = JSON.stringify(this.favourites);

    this.resourceService.editPropertyLine(propertyLine).pipe(takeUntil(this.componentDestroyed)).subscribe(() => {
      this.favourites.map(favourite => {
        if (favourite.Id === this.editableFavourite.Id) {
          favourite.Text = this.editableFavourite.Text;
          favourite.Value = this.editableFavourite.Value;
        }
      });
      this.editableFavourite = null;
      this.updateSpecs();
    });
  }

  openAddRow() {
    this.showAddNew = true;
    this.editableFavourite = new IdTextValueModel();
    this.editableFavourite.Id = Guid.create();
    this.editableFavourite.Value = 'https://';
  }

  add() {
    this.resourceService.addCurrentUserListPropertyLineValue(GLOBAL.Properties.Favourites, this.editableFavourite.Value, this.editableFavourite.Text)
      .pipe(takeUntil(this.componentDestroyed)).subscribe(() => {
      this.showAddNew = false;
      this.editableFavourite = null;
      this.updateSpecs();
    });
  }

  private updateSpecs() {
    let currentUser = this.stateService.currentUser$.value;
    this.resourceService.getCurrentUserSpecs().pipe(takeUntil(this.componentDestroyed)).subscribe(specs => {
      currentUser.Specs = specs;
      this.stateService.currentUser$.next(currentUser);
    });
  }
}
